/*
 * Редактирование кейсета - https://tanker.yandex-team.ru/project/adv-frontend-filters/keyset/components%2FShowSelectedOnlySwitcher%2FShowSelectedOnlySwitcher.i18n.ts
 * Документация локализации - https://a.yandex-team.ru/arcadia/adv/frontend/docs/monorepo/i18n.md
 */
import { createI18n, createI18nRaw, createKeyset } from '@adv-frontend/l10n/src/i18n';
const keyset = createKeyset({
    Все: {
        ru: 'Все',
        en: 'All',
        'en-IE': '',
        tr: 'Tümü',
        'zh-Hans': '全部',
    },
    Выбранные: {
        ru: 'Выбранные',
        en: 'Selected',
        'en-IE': '',
        tr: 'Seçilenler',
        'zh-Hans': '已选择',
    },
});
export const i18n = createI18n(keyset);
export const i18nRaw = createI18nRaw(keyset);
